import { Grid, GridItem, Image } from '@chakra-ui/react';
import { BigNumber } from '@ethersproject/bignumber';
import { SilverSeparator } from '@ui/components/Atoms/Separator/SilverSeparator';
import VaultInfoRow from '@ui/components/Atoms/VaultInfoRow';
import Layout from '@ui/components/Layout';
import MyBaraTokenSection from '@ui/components/Molecules/MyBaraTokenSection';
import VaultRewardInfoSection from '@ui/components/Molecules/VaultRewardInfoSection';
import VaultCardSection from '@ui/components/Organisms/VaultCardSection';
import { BaraVaultContractProvider } from '@ui/contexts/BaraVaultContractContext';
import {
  isDesktopAndUpFn,
  useBreakpointFn,
} from '@ui/hooks/chakra/useBreakpointFn';
import useVaultInfoList from '@ui/hooks/contracts/BaraVault/useVaultInfoList';
import type { NextPage } from 'next';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

export const Page: NextPage = () => {
  const { data } = useVaultInfoList();

  const totalStakedAmount = useMemo(() => {
    return data?.reduce(
      (acc, item) => acc.add(item.totalAmount),
      BigNumber.from(0),
    );
  }, [data]);
  const isDesktopAndUp = useBreakpointFn(isDesktopAndUpFn);

  const t = useTranslations();

  return (
    <BaraVaultContractProvider>
      <Layout>
        <Grid
          w="full"
          alignItems="center"
          templateColumns="repeat(2, 1fr)"
          gridAutoColumns="max-content"
          rowGap={{ lg: 10 }}
          px={{ base: 4, lg: 16 }}
          pt={{ base: 4, lg: 10 }}
          pb={{ base: 10, lg: 20 }}
        >
          <GridItem alignSelf="self-start">
            <Image
              src="/texts/earn.png"
              alt="earn"
              width={{ base: '97px', lg: '220px' }}
            />
          </GridItem>
          <GridItem>
            <VaultRewardInfoSection />
          </GridItem>
          <GridItem colSpan={{ base: 2, lg: 1 }} p="4" h="full">
            <SilverSeparator
              orientation="horizontal"
              my={10}
              display={{ lg: 'none' }}
            />
            <Image
              src={
                isDesktopAndUp
                  ? '/texts/baraVault.png'
                  : '/texts/baraVault-mobile.png'
              }
              width={{ base: '203px' }}
              mx={{ base: 'auto', lg: 0 }}
              alt="stake-capybara"
              mb={{ base: 2, lg: 6 }}
            />
            {data && (
              <VaultInfoRow
                alignItems={{ base: 'center', lg: 'flex-start' }}
                label={t('common.Total Staked')}
                amount={totalStakedAmount}
                labelProps={{ textStyle: 'h4' }}
                tokenProps={{
                  iconSize: 6,
                  stackProps: {
                    alignItems: { base: 'center', lg: 'start' },
                  },
                }}
              />
            )}
          </GridItem>
          <GridItem colSpan={{ base: 2, lg: 1 }}>
            <MyBaraTokenSection />
            <VaultCardSection />
          </GridItem>
        </Grid>
      </Layout>
    </BaraVaultContractProvider>
  );
};
